function getStage(): "dev" | "prod" {
  const stage = process.env.REACT_APP_STAGE;
  if (stage !== "dev" && stage !== "prod") {
    throw new Error(
      "Invalid STAGE environmental variable. Validate your .env files"
    );
  }
  return stage;
}

function getGATrackingCode(): string {
  const trackingCode = process.env.REACT_APP_GA_TRACKING_CODE;
  if (trackingCode === undefined || trackingCode === "") {
    throw new Error(
      "Invalid GA_TRACKING_CODE environmental variable. Validate your .env files"
    );
  }
  return trackingCode;
}

export default { getStage, getGATrackingCode };
